import { selectChangeMessageForLinks } from '@UI/aside/asideLinks/asideLinksSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type ExtendedRootNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { shortDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import constants from '../../../reduxLoop/constants/constants';
import { wwwDefaultBuildingBlocks, wwwTitleAndDescriptionComps } from './wwwGenericConfigProps';

export const WWW_HOME_PAGE: ExtendedRootNodeConfig = {
  extends: NodeType.WWW,
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'WWW. Home',
    plural: 'WWW. Home',
    icon: require('../../../../img/icons/webpage.svg'),
  },
  buildingBlocks: [
    ...wwwDefaultBuildingBlocks,
    {
      type: NodeType.REFERENCE_GROUP,
    },
  ],
  referenceGroupTypes: [
    constants.referenceGroupTypes.WWW_NEWS_ITEM,
    constants.referenceGroupTypes.WWW_CURRENT_THEME,
  ],
  tocTypes: [NodeType.SECTION],
  edit: [
    ...wwwTitleAndDescriptionComps,
    shortDescriptionComponent,
    {
      ...imageComponentBase,
      width: 6,
      label: 'Omslagfoto',
      options: {
        type: 'COVER_IMAGE',
        crop: {}, // Crop without enforced aspectRatio
        fields: [],
      },
    },
    authorsComponent,
    publishComponent,
    {
      component: 'linkGroup',
      reactComponent: 'AsideLinks',
      asideChangeMessageSelector: selectChangeMessageForLinks,

      label: 'Gerelateerd thema on PRO',
      options: {
        type: 'group',
        modalTitle: 'Gerelateerd thema on PRO invoegen',
      },
      hiddenChildren: {
        containerType: ContentType.LINK_GROUP,
        items: [
          {
            type: ContentType.REFERENCE,
            label: 'link',
          },
        ],
      },
    },
  ],
  webTab: asideWebBasicConfiguration,
};
